import {initAiAura} from "../../../default/global/js/chatbot/aiAura";
import {initAIChats} from "../../../default/global/js/chatbot/chatbot";

window.addEventListener("load",()=>{
    initAiAura();
    initAIChats();
});